import styled from 'styled-components';

export const StyledShortInfo = styled.div`
  width: 100%;
  height: 100%;
  border: 2px solid ${(props): string => props.theme.colors.brightGrey};
  padding: 16px;
  gap: 12px;

  .ant-flex {
    height: 100%;
  }

  .short-info__icon {
    width: 24px;

    svg {
      width: 24px;
      height: 24px;
    }
  }

  .short-info__title {
    margin-top: 8px;
    margin-bottom: 12px;
    ${(props): string => props.theme.fontStyles.redesign.sm.strong};
    font-weight: 700;
    word-break: break-word;
    white-space: normal;
  }

  .short-info__value-string {
    display: flex;
    justify-content: center;
    overflow: hidden;
    height: 20px;
    font-size: 20px;
    line-height: 20px;
    font-weight: 700;
    color: inherit;
    margin: 0;
    padding: 0;
  }

  .short-info__unit {
    ${(props): string => props.theme.fontStyles.redesign.xl.strong};
    line-height: 20px;
    font-weight: 700;
    word-break: break-word;
    white-space: normal;
    margin: 0;
  }

  .odometer-wrapper {
    ${(props): string => props.theme.fontStyles.redesign.xl.strong};
    font-weight: 700;
    height: 20px;
    line-height: 20px;
    word-break: break-word;
    white-space: normal;
  }
`;
